const faqs = [
  {
    q: '爱豆影视是否需要注册才能观看？',
    a: '完全不需要！所有综艺内容均可免费在线观看，无需注册登录，打开即看。我们致力于为观众提供最便捷的观影体验，没有任何门槛。',
  },
  {
    q: '视频播放会卡顿或缓冲吗？',
    a: '我们采用先进的CDN加速技术，确保高清视频流畅播放，不缓冲不卡顿。无论您是观看热门综艺还是最新真人秀，都能享受丝滑流畅的观影体验。',
  },
  {
    q: '支持哪些设备观看？',
    a: '爱豆影视完美适配电脑、平板和手机端，无论您使用什么设备，都能享受流畅的高清画质。页面自动适配屏幕尺寸，随时随地畅享偶像综艺。',
  },
  {
    q: '综艺内容多久更新一次？',
    a: '热门综艺播出后最快2小时内同步更新，确保您第一时间观看到最新内容。我们拥有专业的更新团队，每日持续追踪国内外热门综艺动态，绝不错过任何精彩。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于爱豆影视在线观看的常见疑问解答
        </p>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-6 h-6 hidden group-open:flex items-center justify-center text-foreground-400">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}